import React, { useEffect, useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import { Link, useNavigate } from 'react-router-dom';

const settings = [
  { label: 'Logout', route: '/' }
];
const masterItems = [
//   { label: 'User Master', route: '/m-1' },
//   { label: 'Mine Master', route: '/m-2' },
  { label: 'Product Master', route: '/m-3' },
  { label: 'Rate Master', route: '/m-4' },
  { label: 'Customer Master', route: '/m-5' }
];
const transactionItems = [
//   { label: 'Assign Mine To User', route: '/trans-1' },
  { label: 'Sale Entry', route: '/trans-2' },
  { label: 'Payment Receive', route: '/trans-3' },
  { label: 'Expenses Entry', route: '/trans-4' }
];
const reportItems = [
  { label: 'Daily Sale Summery', route: '/r-1' },
  { label: 'Receipt Summery', route: '/r-2' },
  { label: 'Payment Pending Summery', route: '/r-3' },
];

function UserNavbar() {
  const navigate = useNavigate();
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [anchorElMaster, setAnchorElMaster] = useState(null);
  const [anchorElTransaction, setAnchorElTransaction] = useState(null);
  const [anchorElReport, setAnchorElReport] = useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleOpenMasterMenu = (event) => {
    setAnchorElMaster(event.currentTarget);
  };

  const handleOpenTransactionMenu = (event) => {
    setAnchorElTransaction(event.currentTarget);
  };

  const handleOpenReportMenu = (event) => {
    setAnchorElReport(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleCloseMasterMenu = () => {
    setAnchorElMaster(null);
  };

  const handleCloseTransactionMenu = () => {
    setAnchorElTransaction(null);
  };

  const handleCloseReportMenu = () => {
    setAnchorElReport(null);
  };

  const handleMasterItemClick = (route) => {
    navigate(route);
    handleCloseMasterMenu();
  };

  const handleTransactionItemClick = (route) => {
    navigate(route);
    handleCloseTransactionMenu();
  };

  const handleReportItemClick = (route) => {
    navigate(route);
    handleCloseReportMenu();
  };


//   useEffect(() => {
//     let sessionData =  sessionStorage.getItem('memberData');
//     if(!sessionData){
//   navigate('/')
// }  
//   }, [])

  return (
    <AppBar position="static" style={{ backgroundColor: "#001F3F" }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <AdbIcon sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} />
          <Typography
            variant="h6"
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            LOGO
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="menu"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              anchorEl={anchorElNav}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
            >
             <MenuItem onClick={() => navigate('/dashboard')}>
                <Typography sx={{ textAlign: 'center' }}>Dashboard</Typography>
              </MenuItem>
              <MenuItem onClick={handleOpenMasterMenu}>
                <Typography sx={{ textAlign: 'center' }}>Masters</Typography>
              </MenuItem>
              <MenuItem onClick={handleOpenTransactionMenu}>
                <Typography sx={{ textAlign: 'center' }}>Transactions</Typography>
              </MenuItem>             
              <MenuItem onClick={handleOpenReportMenu}>
                <Typography sx={{ textAlign: 'center' }}>Reports</Typography>
              </MenuItem>
            </Menu>
          </Box>

          <AdbIcon sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }} />
          <Typography
            variant="h5"
            noWrap
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            LOGO
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
          <Button sx={{ my: 2, color: 'white', display: 'block' }} onClick={() => navigate('/dashboard')}>Dashboard</Button>
            <Button
              sx={{ my: 2, color: 'white', display: 'block' }}
              onClick={handleOpenMasterMenu}
            >
              Masters
            </Button>
            <Menu
              anchorEl={anchorElMaster}
              open={Boolean(anchorElMaster)}
              onClose={handleCloseMasterMenu}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
            >
              {masterItems.map((item) => (
                <MenuItem
                  key={item.label}
                  onClick={() => handleMasterItemClick(item.route)}
                >
                  {item.label}
                </MenuItem>
              ))}
            </Menu>

            <Button
              sx={{ my: 2, color: 'white', display: 'block' }}
              onClick={handleOpenTransactionMenu}
            >
              Transactions
            </Button>
            <Menu
              anchorEl={anchorElTransaction}
              open={Boolean(anchorElTransaction)}
              onClose={handleCloseTransactionMenu}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
            >
              {transactionItems.map((item) => (
                <MenuItem
                  key={item.label}
                  onClick={() => handleTransactionItemClick(item.route)}
                >
                  {item.label}
                </MenuItem>
              ))}
            </Menu>
            
  
            <Button
              sx={{ my: 2, color: 'white', display: 'block' }}
              onClick={handleOpenReportMenu}
            >
              Report
            </Button>
            <Menu
              anchorEl={anchorElReport}
              open={Boolean(anchorElReport)}
              onClose={handleCloseReportMenu}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
            >
              {reportItems.map((item) => (
                <MenuItem
                  key={item.label}
                  onClick={() => handleReportItemClick(item.route)}
                >
                  {item.label}
                </MenuItem>
              ))}
            </Menu>
          </Box>

          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar alt="User Avatar" src="/static/images/avatar/2.jpg" />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting) => (
                <MenuItem 
                  key={setting.label} 
                  onClick={() => {
                    navigate(setting.route); 
                    handleCloseUserMenu(); 
                  }}
                >
                  <Typography sx={{ textAlign: 'center' }}>{setting.label}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
        <footer className='fixed-bottom'>
        <Typography variant="body2" className='py-1' style={{ backgroundColor: "rgb(0, 31, 63)" }} align="center">
          {'Developed by TechnoAarv Solution'}
          {/* <Link color="inherit" href="https://www.your-site.com">
            {'Your Site'}
          </Link> */}
        </Typography>
        </footer>
      </Container>
    </AppBar>
  );
}

export default UserNavbar;
